var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGripLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288 128C288 110.3 273.7 96 256 96C238.3 96 224 110.3 224 128L224 512C224 529.7 238.3 544 256 544C273.7 544 288 529.7 288 512L288 128zM416 128C416 110.3 401.7 96 384 96C366.3 96 352 110.3 352 128L352 512C352 529.7 366.3 544 384 544C401.7 544 416 529.7 416 512L416 128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripLines);
export default __webpack_public_path__ + "static/media/grip-lines.2bb9995ff30ad202a4da0c987b2c7791.svg";
export { ForwardRef as ReactComponent };